import {
    Grid,
    makeStyles,
    TextField,
    createStyles,
    Theme,
    GridSize,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
    })
);

export function StandardTextField(props: {
    id: string;
    label: string;
    name: string;
    value: string | number | Array<string>;
    handleChange: (e: any) => void;
    lg?: GridSize;
    sm?: GridSize;
    xs?: GridSize;
    readOnly?: boolean;
    InputProps?: any;
    error?: boolean;  // Add error prop
    helperText?: string;  // Add helperText prop
}) {
    const classes = useStyles();
    const { id, label, name, value, handleChange, lg, sm, xs, error, helperText } = props;

    return (
        <>
            <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                className={classes.containerLabel}
            >
                <label htmlFor={id} className={classes.inputLabel}>
                    {label}
                </label>
            </Grid>
            <Grid
                item
                lg={lg || 12}
                sm={sm || 12}
                xs={xs || 12}
                className={classes.inpuText}
            >
                <TextField
                    id={id}
                    fullWidth
                    name={name}
                    value={value}
                    onChange={handleChange}
                    variant="outlined"
                    disabled={props.readOnly}
                    error={error}  // Apply error prop to TextField
                    helperText={helperText}  // Apply helperText prop to TextField
                    InputProps={{
                        ...props.InputProps,
                        style: { whiteSpace: 'pre-wrap' }, // Ensure text wraps inside the input box
                    }}
                    multiline
                    rows={1} // Adjust this value as needed for initial rows
                    maxRows={10} // Adjust this value as needed for maximum rows
                />
            </Grid>
        </>
    );
}
